const ASSET = /\.(?:css|js|mjs|map|png|jpe?g|gif|webp|svg|ico|woff2?|ttf|eot|txt|xml|json|mp4|webm|pdf)$/i

function humanizeFilename(src: string) {
  const file = src.split('/').pop()?.split('?')[0] ?? ''
  const base = file.replace(/\.(?:jpe?g|png|gif|webp|svg)$/i, '').replace(/-\d+x\d+$/, '')
  if (!base || /^[0-9_]+$/.test(base) || base.length < 3) return ''
  return base.replace(/[-_]+/g, ' ').replace(/\b\w/g, (ch) => ch.toUpperCase()).trim()
}

function slashInternalHref(html: string) {
  return html.replace(/href="(\/[^"]*)"/g, (full, href: string) => {
    if (href.startsWith('//')) return full
    const [path, rest = ''] = href.split(/(?=[?#])/)
    if (!path || path === '/') return full
    if (ASSET.test(path)) return full
    if (path.endsWith('/')) return full
    return `href="${path}/${rest}"`
  })
}

function fillEmptyAlts(html: string) {
  return html.replace(/<img\b([^>]*?)>/gi, (full, attrs: string) => {
    const src = attrs.match(/src="([^"]+)"/)?.[1] ?? ''
    const label = humanizeFilename(src)
    if (/\balt=""/i.test(attrs) && label) {
      return `<img${attrs.replace(/alt=""/i, `alt="${label}"`)}>`
    }
    if (!/\balt\s*=/.test(attrs)) {
      return `<img${attrs} alt="${label}">`
    }
    return full
  })
}

function noopenerExternal(html: string) {
  return html.replace(/<a\b([^>]*?)>/gi, (full, attrs: string) => {
    const href = attrs.match(/href="([^"]+)"/)?.[1] ?? ''
    if (!/^https?:\/\//i.test(href)) return full
    if (/conmantheseries\.com/i.test(href) && !/store\.conmantheseries\.com/i.test(href)) return full
    if (/\brel=/.test(attrs)) {
      if (!/\bnoopener\b/.test(attrs)) {
        return full.replace(/\brel="([^"]*)"/, (_m, rel: string) => `rel="${rel} noopener"`)
      }
      return full
    }
    return `<a${attrs} rel="noopener">`
  })
}

export function enhanceHtml(html: string) {
  return noopenerExternal(fillEmptyAlts(slashInternalHref(html)))
}

export default function Markup({ html }: { html: string }) {
  return <div dangerouslySetInnerHTML={{ __html: enhanceHtml(html) }} />
}
